import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M13.33 13H8a1 1 0 00-1 1v7', key: '60fs50' }],
  [
    'path',
    {
      d: 'M14.363 17.634a2 2 0 00-.506.854l-.837 2.87a.5.5 0 00.62.62l2.87-.837a2 2 0 00.854-.506l4.013-4.009a1 1 0 10-3.004-3.004z',
      key: 'dpj1he',
    },
  ],
  ['path', { d: 'M7 3v4a1 1 0 001 1h7', key: 'vkun1b' }],
  [
    'path',
    {
      d: 'M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h10.2a2 2 0 011.4.6l3.8 3.8a2 2 0 01.6 1.4v.3',
      key: '1oj3yb',
    },
  ],
];

/**
 * @component @name SavePen
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTMuMzMgMTNIOGExIDEgMCAwMC0xIDF2NyIgLz4KICA8cGF0aCBkPSJNMTQuMzYzIDE3LjYzNGEyIDIgMCAwMC0uNTA2Ljg1NGwtLjgzNyAyLjg3YS41LjUgMCAwMC42Mi42MmwyLjg3LS44MzdhMiAyIDAgMDAuODU0LS41MDZsNC4wMTMtNC4wMDlhMSAxIDAgMTAtMy4wMDQtMy4wMDR6IiAvPgogIDxwYXRoIGQ9Ik03IDN2NGExIDEgMCAwMDEgMWg3IiAvPgogIDxwYXRoIGQ9Ik05IDIxSDVhMiAyIDAgMDEtMi0yVjVhMiAyIDAgMDEyLTJoMTAuMmEyIDIgMCAwMTEuNC42bDMuOCAzLjhhMiAyIDAgMDEuNiAxLjR2LjMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/save-pen
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SavePen = createLucideIcon('save-pen', __iconNode);

export default SavePen;
